'use client'

import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { Tooltip } from '@/components/elementary/Tooltip'
import { Copy } from '@/components/icons/social/Copy'
import { Button } from '@/components/ui/button'
import { COPY_CONTENT_TEST_IDS } from '@/lib/test-ids'

export const CopyContent = ({ shareUrl }: { shareUrl: string }) => {
	const [copied, setCopied] = useState(false)
	const [tooltipOpen, setTooltipOpen] = useState(false)
	const t = useTranslations('CopyContent')

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(shareUrl)
			setTooltipOpen(true)
			setCopied(true)
			setTimeout(() => {
				setCopied(false)
				setTooltipOpen(false)
			}, 2000)
		} catch (err) {
			console.error('Failed to copy:', err)
		}
	}

	return (
		<Tooltip
			content={t(copied ? 'copied' : 'label')}
			open={tooltipOpen}
			onOpenChange={setTooltipOpen}
			asChild
		>
			<Button
				onClick={handleCopy}
				size="none"
				aria-label="Copy Link"
				variant="none"
				data-test-id={COPY_CONTENT_TEST_IDS.COMPONENT}
			>
				<Copy className="text-neutral-light-alpha-500" />
			</Button>
		</Tooltip>
	)
}
